import { defineStore } from "pinia";
import { getDocuments, getDocument } from "@/api/auth";

export const useDocumentStore = defineStore("documents", {
  state: () => ({
    documents: null,
    categories: [],
    documentTypes: [],
    selectedDocumentType: null,
    loading: false,
    error: null,
  }),
  getters: {
    Documents: state => state.documents ?? [],
    Categories: state => state.categories,
    DocumentTypes: state => state.documentTypes,
    CategoriesWithDocuments: state => state.categories.filter(cat => cat.documents && cat.documents.length > 0),
    FilteredDocuments: state => {
      if (!state.documents) return [];

      return state.documents
        .map(category => {
          if (!category.documents || category.documents.length === 0) {
            return { ...category, documents: [] };
          }

          let filteredDocs = (category.documents || []).filter(doc => doc);

          if (state.selectedDocumentType) {
            filteredDocs = filteredDocs.filter(doc => {
              if (!doc.typesAsString) return false;
              const types = doc.typesAsString.split(", ").map(type => type.trim());
              return types.includes(state.selectedDocumentType);
            });
          }

          return {
            ...category,
            documents: filteredDocs,
          };
        })
        .filter(category => category.documents.length > 0);
    },
  },
  actions: {
    async fetchListDocuments() {
      this.loading = true;
      try {
        const res = await getDocuments();
        const categoriesWithDocs = await Promise.all(
          res.data.map(async category => {
            const docs = await Promise.all(
              category.documents.map(async docUrl => {
                const docId = docUrl.split("/").pop();
                try {
                  const docRes = await getDocument(docId);
                  return docRes.data ? docRes.data[0] : null;
                } catch (e) {
                  return null;
                }
              })
            );
            return {
              ...category,
              documents: docs.filter(doc => doc !== null && doc !== undefined),
            };
          })
        );
        this.documents = categoriesWithDocs;
        this.categories = res.data;
        const allTypes = new Set();
        categoriesWithDocs.forEach(category => {
          if (category.documents && category.documents.length > 0) {
            category.documents.forEach(doc => {
              if (doc.typesAsString) {
                const types = doc.typesAsString.split(", ").map(type => type.trim());
                types.forEach(type => allTypes.add(type));
              }
            });
          }
        });
        this.documentTypes = Array.from(allTypes).sort();
        this.loading = false;
      } catch (error) {
        console.error("Erreur lors de la récupération des documents", error);
        this.error = "Erreur lors du chargement des documents";
        this.loading = false;
      }
    },
    setDocumentTypeFilter(documentType) {
      this.selectedDocumentType = documentType;
    },
    clearDocumentTypeFilter() {
      this.selectedDocumentType = null;
    },
  },
});



